<script setup>
import { descargarDatosBancarios } from "@/utils/components";

const emit = defineEmits(["informar-garantia", "pedir-devolucion"]);
</script>

<template>
  <div
    class="d-flex flex-column flex-md-row align-items-md-center gap-3 justify-content-between mb-2"
  >
    <!-- IZQUIERDA -->
    <div>
      <button
        type="button"
        class="btn btn-link uc-download-link p-0 px-2 d-inline-flex align-items-center"
        @click="descargarDatosBancarios"
      >
        <i class="fas fa-download me-2"></i>
        Descargar datos bancarios
      </button>
    </div>

    <!-- DERECHA -->
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="button"
        class="btn uc-btn-devolucion px-5 w-100 w-md-auto"
        @click="emit('pedir-devolucion')"
      >
        Solicitar devolución
      </button>

      <button
        type="button"
        class="btn uc-btn-garantia px-5 w-100 w-md-auto"
        @click="emit('informar-garantia')"
      >
        Informar garantía
      </button>
    </div>
  </div>
</template>

<style scoped>
.uc-download-link {
  color: #006c4c;
  font-weight: 500;
  text-decoration: none;
}
.uc-download-link:hover {
  color: #004f37;
  text-decoration: underline;
}

.uc-btn-devolucion {
  background-color: #a3daa8;
  border-color: #a6dfb7;
  color: #006C4C;
  font-family: Roboto;
  font-size: 0.95rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  border-radius: 4px;
}
.uc-btn-devolucion:hover {
  background-color: #96d3ab;
  border-color: #96d3ab;
  color: #00523a;
}

.uc-btn-garantia {
  background-color: #006c4c;
  border-color: #006c4c;
  color: white;
  font-family: Roboto;
  font-size: 0.95rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  border-radius: 4px;
}
.uc-btn-garantia:hover {
  background-color: #00523a;
  border-color: #00523a;
}
</style>
